<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url("../static/css/iconfont.css");
@import url("./assets/ti_style.css");
body{
  margin: 0;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue